<!--<hr />-->
<div class="row" data-testid="registration-page">
    <div class="col-md-12">
        <div class="panel panel-danger ">
            <div class="panel-heading clearfix">
                <div class="col-sx-12 col-sm-6 col-md-3">
                    <h4 class="panel-title pull-left" data-testid="registration-page-header">UniteHERE Members to register</h4>
                </div>
                <div class="col-sx-12 col-sm-6 col-md-3">
                    <span class="pull-right">{{totalCount}} Members found</span>
                </div>
                <div class="col-sx-12 col-sm-12 col-md-6 col-lg-4">
                    <div class="input-group">
                        <input id="inputSearchMembers" type="search" [(ngModel)]="filterMembers" class="form-control shortInputSearch" placeholder="Filter.."  (keyup.enter)="search(page)" data-testid="registration-search-input">
                        <div class="input-group-btn">
                            <button class="btn btn-primary" (click)="search(page)"><i class="glyphicon glyphicon-search" data-testid="registration-search-button"></i></button>
                            <button class="btn btn-primary" (click)="clearSearch();"><i class="glyphicon glyphicon-remove-sign" data-testid="registration-clear-button"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive" *ngIf="!loadingMembers && strikeMembers.length > 0">
                <table class="table table-striped" data-testid="registration-page-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th width="200px">Name</th>
                            <!--<th>First Name</th>-->
                            <th>Status</th>
                            <th>Ssn        </th>
                            <th>Birth Date</th>
                            <!--<th>StrikeLine</th>
                            <th>StrikeShift</th>-->
                            <th>DebitCard</th>
                            <th>Card Swipe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let member of strikeMembers" data-testid="member-row">
                            <td data-testid="member-id">{{member.MemberId}}</td>
                            <td data-testid="member-name">{{member.LastName+' '+member.MiddleName+ ' ' + member.FirstName}} </td>
                            <!--<td>{{member.FirstName}}</td>-->
                            <td [ngClass]="getStatusColor(member.MemberStatus)" [attr.data-testid]="'register-table-status-' + member.ID" >{{member.MemberStatus}}</td>
                            <td data-testid="member-ssn">{{member.Ssn ? member.Ssn.slice(5) : ""}}</td>
                            <td data-testid="member-birth-date">{{member.BirthDate | date:'MM/dd/yyyy'}}</td>
                            <!--<td>{{member.StrikeLine}}</td>
                            <td>{{member.StrikeShift}}</td>
                            <td>{{member.DebitCardInfo.split('^')[0].substr(2)}}</td>-->
                            <td data-testid="member-debit-info">{{member.DebitCardInfo}}</td>
                            <td><input class="form-control" name="dbCardSwipe" type="text"
                                [(ngModel)]="member.DebitCardInfo" (keyup.enter)="cardSwiped(member);"
                                [attr.data-testid]="'debit-card-input-' + member.MemberId"/></td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <app-custom-pager [page]="page" [pagesCount]="pageCount" (pageChange)="search($event)"></app-custom-pager>
                </div>
            </div>
            <div *ngIf="loadingMembers">
                <div class="col-xs-4"></div>
                <div class="col-xs-4">
                    <i class="fa fa-refresh fa-4x fa-spin"></i> <span class="label label-primary">Loading members...</span>
                </div>
                <div class="col-xs-4"></div>
            </div>
        </div>
    </div>
</div>

